import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
  } from '@angular/core';
import { ITime } from '../durationw-clock/durationw-clock.component';
import { DurationWTimeDialogComponent } from '../durationw-time-dialog/durationw-time-dialog.component';
import { Utils } from '../utils';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'DurationPicker',
  styleUrls: ['./durationpicker.component.scss'],
  templateUrl: './durationpicker.component.html'
})
export class DurationPickerComponent implements OnInit {
  @Input() label = 'Hour';
  @Input() appearance = 'legacy';
  @Input() userTime: ITime;
  @Input() color: string;
  @Input() revertLabel: string;
  @Input() submitLabel: string;


  @Input() hideMeridian: boolean;

  @Output() change: EventEmitter<ITime> = new EventEmitter<ITime>();



  constructor(private dialog: MatDialog) { }

  ngOnInit() {
    if (!this.userTime) {
      this.userTime = {
        hour: 0,
        minute: 0,
        meriden: 'PM',
        format: 24
      };
    }
  }

  time(): string {
    if (!this.userTime) {
      return '';
    }

    //let meriden = `${this.userTime.meriden}`;
    //if (this.userTime.format === 24) {
    //  meriden = '';
    //}

     let meriden = '';

    let hour = `${this.userTime.hour}`;
    if (this.userTime.hour === 24) {
      hour = '00';
    }

    if (this.userTime.minute === 0) {
      return `${hour}:00 ${meriden}`;
    } else if (this.userTime.minute < 10) {
      const tt = '0' + String(this.userTime.minute);
      return `${hour}:${tt} ${meriden}`;
    } else {
      return `${hour}:${this.userTime.minute} ${meriden}`;
    }
  }

  showPicker() {
    const dialogRef = this.dialog.open(DurationWTimeDialogComponent, {
      data: {
        time: {
          hour: this.userTime.hour,
          minute: this.userTime.minute,
          meriden: this.userTime.meriden,
          format: this.userTime.format
        },
        color: this.color,
        revertLabel: this.revertLabel,
        submitLabel: this.submitLabel,
        hideMeridian: this.hideMeridian
      }
    });

    dialogRef.afterClosed().subscribe((result: ITime | -1) => {
      // result will be update userTime object or -1 or undefined (closed dialog w/o clicking cancel)
      if (result === undefined) {
        return;
      } else if (result !== -1) {
        this.userTime = result;

        const hour = result.hour;
        const minute = result.minute;

        const dataEvent = {
          hour: Utils.formatHour(result.format, hour),
          minute: Utils.formatMinute(minute),
          meriden: this.userTime.meriden,
          format: this.userTime.format
        };

        if (dataEvent.minute === '00') {
          dataEvent.minute = '0';
        }

        this.emitChange(dataEvent);
      }
    });
    return false;
  }

  private emitChange(data) {
    this.change.emit(data);
  }
}
